module.exports = __webpack_public_path__ + "static/img/strona_025.ccb6c296.jpg";